<template>
  <div >
    <video-form v-if="edit" :video="video" @succes="edit=false"></video-form>
    <div v-if="!edit" class="vcontainer">
      <iframe :src="'//www.youtube.com/embed/' + videoId"
        frameborder="0" allowfullscreen class="video"></iframe>
    </div>
    <v-toolbar color="primary" dark dense>
      <v-toolbar-title><div class="body-2">Dodany {{ video.created_at | formatDate('LL') }} przez {{ video.user_name }}</div></v-toolbar-title>
          <v-spacer></v-spacer>
          <rp-icon
            v-if="isAdmin || isTriner"
            type="edit"
            tooltip="edytuj"
            dark
            @click="edit = !edit"
          />
          <rp-icon
            v-if="isAdmin || isTriner"
            type="delete"
            tooltip="usuń"
            dark
            @click="$emit('remove-video'); edit=false"
          />
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoForm from './VideoForm'
import GetYouTubeID from 'get-youtube-id'
export default {
  components: {VideoForm},
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      edit: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isTrainer']),
    videoId () {
      return GetYouTubeID(this.video.link)
    }
  }
}
</script>
<style>
.youtube-video {
  max-width: 700px;
}
.vcontainer {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
}
.video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/videos/VideoItem.vue